var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdditionalDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 10,
    fill: "#EAF0F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.33 34.8H18.55a2.9 2.9 0 01-2.95-2.95v-15.7a2.9 2.9 0 012.95-2.95h7.85a.6.6 0 01.4.1c.09 0 .19.1.29.2l5.89 5.89.1.14c.02.06.05.1.1.15a.6.6 0 01.09.4v11.77a2.9 2.9 0 01-2.94 2.95zM18.55 15.17a.93.93 0 00-.99.98v15.7a.93.93 0 00.99.99h11.78a.93.93 0 00.98-.99v-10.8H26.4a.93.93 0 01-.98-.98v-4.9h-6.87zm8.83 1.37v2.55h2.55l-2.55-2.55zm.98 13.35h-7.85a.98.98 0 110-1.96h7.85a.98.98 0 110 1.96zm0-3.93h-7.85a.98.98 0 010-1.96h7.85a.98.98 0 110 1.96zm-5.89-3.92h-1.96a.93.93 0 01-.98-.98.93.93 0 01.98-.99h1.96a.93.93 0 01.98.99.93.93 0 01-.98.98z",
    fill: "#3639A4"
  })));
}
export default SvgAdditionalDocuments;